import axios, { AxiosInstance, AxiosResponse } from 'axios'
import { ApiResponse } from '../types'

// Create axios instance with base configuration
const api: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:8787',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor for authentication
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - clear token and redirect to login
      localStorage.removeItem('auth_token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// API service functions
export const authAPI = {
  login: async (credentials: { email: string; password: string }) => {
    const response = await api.post<ApiResponse<{ user: any; token: string }>>('/auth/login', credentials)
    return response.data
  },
  
  logout: async () => {
    const response = await api.post<ApiResponse<void>>('/auth/logout')
    return response.data
  },
  
  me: async () => {
    const response = await api.get<ApiResponse<any>>('/auth/me')
    return response.data
  },
}

export const projectsAPI = {
  getAll: async (params?: { page?: number; limit?: number; sortBy?: string; sortOrder?: 'asc' | 'desc' }) => {
    const response = await api.get<ApiResponse<any[]>>('/api/projects', { params })
    return response.data
  },
  
  getById: async (id: string) => {
    const response = await api.get<ApiResponse<any>>(`/api/projects/${id}`)
    return response.data
  },
  
  create: async (project: any) => {
    const response = await api.post<ApiResponse<any>>('/api/projects', project)
    return response.data
  },
  
  update: async (id: string, project: any) => {
    const response = await api.put<ApiResponse<any>>(`/api/projects/${id}`, project)
    return response.data
  },
  
  delete: async (id: string) => {
    const response = await api.delete<ApiResponse<void>>(`/api/projects/${id}`)
    return response.data
  },
}

export const dashboardAPI = {
  getStats: async () => {
    const response = await api.get<ApiResponse<any>>('/api/stats')
    return response.data
  },
  
  getAnalytics: async () => {
    const response = await api.get<ApiResponse<any>>('/api/stats')
    return response.data
  },
}

export { api } 